import { XCircleIcon } from "@heroicons/react/20/solid";

export default function ErrorAlert({ text }: { text: string }) {
	return (
		<div className="cC-rounded-md cC-bg-red-50 cC-p-4 cC-mt-2">
			<div className="cC-flex">
				<div className="cC-flex-shrink-0">
					<XCircleIcon className="cC-h-5 w-5 cC-text-red-400" aria-hidden="true" />
				</div>
				<div className="cC-ml-3">
					<h3 className="cC-text-sm cC-mt-0 cC-font-medium cC-text-red-800">{text}</h3>
				</div>
			</div>
		</div>
	);
}
